module.exports = __webpack_public_path__ + "img/tutorial_000.ecdd029f.png";